import type { MouseEvent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { RowBetween } from '../../../../components/common'
import { Text } from '../../../../components/text'
import { List, Item, TitleBox, ContentsContainer } from './styled'

interface SettingListContainerProps {
  items: ListItem[]
  itemGap?: number
}

interface ListItem {
  title?: string
  isBorder?: boolean
  list: {
    title: string | JSX.Element
    icon?: any
    rightContent?: any
    link?: string
    onClick?: (e?: MouseEvent<HTMLElement>) => void
  }[]
}

export function SettingListContainer({ items, itemGap }: SettingListContainerProps) {
  return (
    <List>
      {items.map(({ isBorder = true, title, list }, itemIndex) => (
        <Item key={itemIndex} itemGap={itemGap} isBorder={isBorder}>
          {title && (
            <Text size={14} lineHeight={22} color="text_secondary" block={true}>
              {title}
            </Text>
          )}
          {list.map(({ title, icon, rightContent, link, onClick }, index) => {
            const handleClick = (e?: MouseEvent<HTMLElement>) => {
              onClick?.(e)
            }

            const Content = () => {
              return (
                <ContentRow {...(typeof link !== 'string' ? { onClick: handleClick } : '')}>
                  <TitleBox>
                    {icon}
                    {typeof title === 'string' ? (
                      <Text size={18} weight={500}>
                        {title}
                      </Text>
                    ) : (
                      title
                    )}
                  </TitleBox>
                  {rightContent && <>{rightContent}</>}
                </ContentRow>
              )
            }

            return (
              <ContentsContainer key={index}>
                {typeof link === 'string' ? (
                  <Link to={link} onClick={handleClick}>
                    <Content />
                  </Link>
                ) : (
                  <Content />
                )}
              </ContentsContainer>
            )
          })}
        </Item>
      ))}
    </List>
  )
}

const ContentRow = styled(RowBetween)`
  cursor: pointer;
`

export type { SettingListContainerProps, ListItem }
